export default function NotFound() {
  return <p className="text-5xl text-center mt-40">未找到您所要查找的页面</p>;
}
